
import { Injectable } from '@angular/core';
import { RestApi } from '../../../auth/rest.api';
import { EventLog } from '../models/eventlog';
import { FilteredEventLogData } from '../models/filteredeventlogtype';
import { Observable } from 'rxjs';
import { saveFile } from 'app/app.module';
import { catchError, mergeMap } from 'rxjs/operators';

@Injectable()
export class EventLogService {
  private api_eventLog = 'api/EventLog/';
  private api_eventLog_filtered = 'api/EventLog/filtered';
  private api_eventLog_csv_separator = 'api/EventLog/defaultSeparator';
  private api_eventLog_detail = 'api/EventLog/Detail';
  private api_eventLog_delete = 'api/EventLog/Delete';
  private api_eventLog_download = 'api/EventLog/Download';

  constructor(private _authHttp: RestApi) {
  }


  getEventLogDetail(filterCriteria: IEventLogFilter): any {
    return this._authHttp.post(this.api_eventLog_detail, filterCriteria);
  }

  downloadEventLog(filterCriteria: IEventLogFilter) {
    return this._authHttp.requestBlob({ body: filterCriteria, url: this.api_eventLog_download, parameters: [] }, 'POST')
      .map(result => {
        const fileName: string = this._authHttp.getFileNameFromHeaders(result.headers, 'EventLog.csv');
          if (navigator.appVersion.toString().indexOf('.NET') > 0) {
            saveFile(new Blob([result.body], { type: 'application/octet-stream' }), fileName);
          }
          else {
              const pdfUrl = (
                window.URL || window['webkitURL']
              ).createObjectURL(
                new Blob([result.body], { type: 'application/octet-stream' })
              );
              const anchor = document.createElement('a');
              anchor.download = fileName;
              anchor.href = pdfUrl;
              anchor.click();
          }
      })
      .catch((err) => Observable.throw(err._body));
  }

  public getDefaultSeparatorForCSS(): Observable<string> {
    return this._authHttp.get(this.api_eventLog_csv_separator).pipe(
      mergeMap(async (res) => {
        try {
          const body = await res.json();
          return body?.separator;
        } catch (error) {
          console.error('Error parsing response:', error);
          throw error;
        }
      }),
      catchError(this.handleError)
    );
  }

  public removeEventLogs(eventLogs: any) {
    return this._authHttp.post(this.api_eventLog_delete, eventLogs);
  }

  private async handleError(err: Response | any) {
    let errorMsg: string;
    if (err instanceof Response) {
      try {
        const body = await err.json(); // Await the Promise
        const error = body.error || JSON.stringify(body);
        errorMsg = `${error.status} - ${error.statusText || ''} ${error}`;
      } catch (error) {
        errorMsg = `Error parsing response body: ${error.message}`;
      }
    } else {
      errorMsg = err.message ? err.message : err.toString();
    }
    return Observable.throw(errorMsg);
  }

  private extractData(res: Response) {
    const body = res.json();
    return body || {};
  }

}

